import { ID, Url } from '../../utils/codecUtils';
import { IntegrationCredentialSecret } from '../models/integrationCredential';
import { integrationCredentialSchema } from '../models/integrationCredential.schema';
import { patchIntegrationCredentialPayloadSchema } from './patch.schema';

export type PatchIntegrationCredentialPayload = {
  name?: string;
  secret?: IntegrationCredentialSecret;
  organization?: Url;
};

export const patch = (
  integrationCredentialId: ID,
  payload: PatchIntegrationCredentialPayload
) => {
  return {
    endpoint: `/integration_credentials/${integrationCredentialId}`,
    method: 'PATCH',
    payload,
    responseSchema: integrationCredentialSchema,
    payloadSchema: patchIntegrationCredentialPayloadSchema,
  } as const;
};
